import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetMultiRequestsByMultiRequestIdQueryResponse, GetMultiRequestsByMultiRequestIdPathParams, GetMultiRequestsByMultiRequestIdQueryParams, GetMultiRequestsByMultiRequestId400, GetMultiRequestsByMultiRequestId404, GetMultiRequestsByMultiRequestId500 } from "../types/GetMultiRequestsByMultiRequestId";

export const getMultiRequestsByMultiRequestIdQueryKey = (multiRequestId: GetMultiRequestsByMultiRequestIdPathParams["multiRequestId"], params?: GetMultiRequestsByMultiRequestIdQueryParams) =>     [{url:`/api/v2/multirequests/${multiRequestId}`,params:{multiRequestId:multiRequestId}},...(params ? [params] : [])] as const;
      export function getMultiRequestsByMultiRequestIdQueryOptions <TData = GetMultiRequestsByMultiRequestIdQueryResponse, TError = GetMultiRequestsByMultiRequestId400 | GetMultiRequestsByMultiRequestId404 | GetMultiRequestsByMultiRequestId500>(multiRequestId: GetMultiRequestsByMultiRequestIdPathParams["multiRequestId"], params?: GetMultiRequestsByMultiRequestIdQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getMultiRequestsByMultiRequestIdQueryKey(multiRequestId, params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/v2/multirequests/${multiRequestId}`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Отображение мультизаявки(со всеми вложенными заявками)
 * @link /api/v2/multirequests/:multiRequestId
 */

export function useGetMultiRequestsByMultiRequestId <TData = GetMultiRequestsByMultiRequestIdQueryResponse, TError = GetMultiRequestsByMultiRequestId400 | GetMultiRequestsByMultiRequestId404 | GetMultiRequestsByMultiRequestId500>(multiRequestId: GetMultiRequestsByMultiRequestIdPathParams["multiRequestId"], params?: GetMultiRequestsByMultiRequestIdQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getMultiRequestsByMultiRequestIdQueryKey(multiRequestId, params);

  const query = useQuery<TData, TError>({
    ...getMultiRequestsByMultiRequestIdQueryOptions<TData, TError>(multiRequestId, params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
